import Modal from 'components/Modal';
import styled from 'styled-components';
import { PACKAGE_THEME_COLORS, PackageThemeKey } from 'features/cashier/services/package-theme';

export const ModalStyled = styled(Modal)`
  /* Modal cua project set mau title o styled rieng, can specificity cao hon de doi sang trang */
  &&& .ant-modal-header {
    height: 3.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #232B3F;
  }

  &&& .ant-modal-title {
    width: 100%;
    color: #FFFFFF;
    text-align: center;
    font-family: Poppins;
    font-size: 1.625rem;
    font-weight: 600;
    letter-spacing: 0.5px;
  }
`;

/*
 * Thân modal phóng to 40% so với bản vẽ 1000px; modal đã nới lên 1400px cùng tỉ lệ nên bố cục bên trong giữ nguyên.
 * zoom nhân cả đơn vị vh, nên 45vh ở đây hiện ra khoảng 63vh.
 */
export const BODY_ZOOM = 1.4;

export const BodyStyled = styled.div`
  zoom: ${BODY_ZOOM};
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 24px;
  background: #F5F6F8;
  font-family: Poppins;
  max-height: 45vh;
  overflow-y: auto;
`;

export const CustomerCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px;
  border-radius: 8px;
  background: #FFFFFF;

  .customer-info {
    display: flex;
    align-items: center;
    gap: 16px;
    overflow: hidden;
  }

  .avatar {
    flex-shrink: 0;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #8AA9BC;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 600;
  }

  .customer-name {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: #1D2129;
  }

  .customer-point {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: #D2464F;
  }

  .available-sessions {
    text-align: center;
    padding-left: 24px;
    border-left: 1px solid #E5E6EB;
  }

  .available-value {
    margin: 0;
    font-size: 40px;
    font-weight: 700;
    line-height: 44px;
    color: #1D2129;
  }

  .available-label {
    margin: 0;
    font-size: 15px;
    color: #64748B;
  }
`;

export const PackageRow = styled.div<{ themeKey: PackageThemeKey }>`
  /* cột tên gói phải co giãn: width cố định ở 3 cột kia ép cột này còn vài chục px, chữ rớt từng ký tự */
  display: grid;
  grid-template-columns: 180px minmax(0, 1.3fr) minmax(0, 1fr) minmax(0, 1.1fr);
  align-items: stretch;
  border-radius: 8px;
  border: 1px solid ${({ themeKey }) => PACKAGE_THEME_COLORS[themeKey].main};
  background: #FFFFFF;
  overflow: hidden;

  .tier-side {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 16px;
    background: ${({ themeKey }) => `${PACKAGE_THEME_COLORS[themeKey].main}14`};

    img {
      width: 72px;
      height: 72px;
    }

    .tier-badge {
      padding: 4px 18px;
      border-radius: 999px;
      background: ${({ themeKey }) => `${PACKAGE_THEME_COLORS[themeKey].main}26`};
      color: ${({ themeKey }) => PACKAGE_THEME_COLORS[themeKey].main};
      font-size: 14px;
      font-weight: 600;
      text-transform: uppercase;
    }
  }

  .program-side {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 6px;
    padding: 16px;
    min-width: 0;
  }

  .program-name {
    margin: 0;
    font-size: 22px;
    font-weight: 600;
    color: #1D2129;
  }

  .program-description {
    margin: 0;
    font-size: 14px;
    color: #64748B;
  }

  .expires {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    align-self: flex-start;
    padding: 4px 10px;
    border-radius: 6px;
    background: #F1F2F4;
    font-size: 13px;
    color: #64748B;
  }

  .remaining-side {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 16px;
    text-align: center;
    border-left: 1px solid #E5E6EB;

    .remaining-value {
      margin: 0;
      font-size: 34px;
      font-weight: 700;
      line-height: 38px;
      color: #1D2129;
    }

    .remaining-label {
      margin: 0 0 8px;
      font-size: 15px;
      color: #1D2129;
    }

    .progress {
      height: 8px;
      border-radius: 999px;
      background: #E5E6EB;
      overflow: hidden;
    }

    .progress-value {
      height: 100%;
      background: ${({ themeKey }) => PACKAGE_THEME_COLORS[themeKey].main};
    }

    .total-label {
      margin: 6px 0 0;
      font-size: 14px;
      color: #64748B;
    }
  }

  .use-side {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 16px;
    text-align: center;
    border-left: 1px solid #E5E6EB;

    .use-label {
      margin: 0 0 8px;
      font-size: 15px;
      color: #64748B;
    }

    .stepper {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
    }

    .stepper-button {
      flex-shrink: 0;
      width: 48px;
      height: 46px;
      border: none;
      border-radius: 8px;
      background: #E5E6EB;
      color: #1D2129;
      font-size: 22px;
      font-weight: 600;
      cursor: pointer;

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }

    .stepper-value {
      width: 72px;
      height: 46px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #E5E6EB;
      border-radius: 8px;
      font-size: 22px;
      font-weight: 600;
      color: #1D2129;
    }

    .maximum-label {
      margin: 8px 0 0;
      font-size: 14px;
      color: #D2464F;
    }
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  width: 100%;
  gap: 12px;
  /* modal dùng noneBodyStyle nên antd bỏ hết padding footer, tự chứa ở đây */
  padding: 16px;

  button {
    flex: 1;
    height: 4.5rem;
    border: none;
    border-radius: 6px;
    font-family: Poppins;
    font-size: 1.6rem;
    font-weight: 600;
    white-space: nowrap;
    cursor: pointer;
  }
`;

export const CloseButton = styled.button`
  background: #E5E6EB;
  color: #1D2129;
`;

export const OkButton = styled.button`
  background: #D2464F;
  color: #FFFFFF;

  &:disabled {
    background: #FFE1E3;
    color: #FFFFFF;
    cursor: not-allowed;
  }
`;
